import { EREIGNIS_LABEL, formatDatum } from "@stammbaum/shared";
import type { FamilieAnzeige, EreignisAnzeige } from "../api";

/**
 * Beschriftungen für Familien und Ereignisse.
 *
 * Eine Familie heißt in der Datenbank „Huber" — was bei zwanzig Hubers
 * nichts sagt. Also steht hier immer dabei, wer gemeint ist.
 */

export const personName = (p: { vorname?: string; famname?: string }) =>
  `${p.vorname ?? ""} ${p.famname ?? ""}`.trim() || "ohne Namen";

export function familieText(f: FamilieAnzeige): string {
  const eltern = f.mitglieder.filter((m) => m.rolle === "elternteil");
  const kinder = f.mitglieder.filter((m) => m.rolle === "kind");

  const kern = eltern.length
    ? eltern.map(personName).join(" & ")
    : kinder.slice(0, 3).map(personName).join(", ");

  const anhang =
    eltern.length && kinder.length
      ? ` (${kinder.length} ${kinder.length === 1 ? "Kind" : "Kinder"})`
      : "";

  return kern ? `${kern}${anhang}` : (f.bezeichnung ?? "Familie ohne Mitglieder");
}

export function ereignisDatumText(e: EreignisAnzeige): string | null {
  if (!e.datumVon && !e.datumText) return null;
  return formatDatum({
    von: e.datumVon,
    bis: e.datumBis,
    genauigkeit: e.datumGenauigkeit ?? "jahr",
    text: e.datumText,
  });
}

export function ereignisText(e: EreignisAnzeige): string {
  // Nur Haupt- und Partnerrollen in die Kurzfassung: Trauzeugen gehören
  // nicht in die Überschrift.
  const wer = e.beteiligte
    .filter((b) => b.rolle === "hauptperson" || b.rolle === "partner")
    .map(personName);

  return [
    EREIGNIS_LABEL[e.art as keyof typeof EREIGNIS_LABEL] ?? e.art,
    wer.join(" & ") || null,
    ereignisDatumText(e),
    e.ortName,
  ]
    .filter(Boolean)
    .join(" · ");
}
